import { type ReactNode, useCallback, useRef, useState } from "react";
import { Button } from "./Button";
import { Dialog } from "./Dialog";

export type ConfirmOptions = { title: string; body: ReactNode; confirmLabel: string; danger?: boolean };

export function useConfirm(): { confirm: (options: ConfirmOptions) => Promise<boolean>; element: ReactNode } {
  const [options, setOptions] = useState<ConfirmOptions | null>(null);
  const resolver = useRef<((v: boolean) => void) | null>(null);
  const confirm = useCallback((o: ConfirmOptions) => {
    resolver.current?.(false);
    setOptions(o);
    return new Promise<boolean>((resolve) => {
      resolver.current = resolve;
    });
  }, []);
  const finish = (answer: boolean) => {
    resolver.current?.(answer);
    resolver.current = null;
    setOptions(null);
  };
  const element = (
    <Dialog
      open={options !== null}
      onClose={() => finish(false)}
      title={options?.title ?? ""}
      size="sm"
      footer={
        <>
          <Button onClick={() => finish(false)}>Cancel</Button>
          <Button variant={options?.danger ? "danger" : "primary"} onClick={() => finish(true)}>
            {options?.confirmLabel ?? "OK"}
          </Button>
        </>
      }
    >
      <div className="text-ink-2">{options?.body}</div>
    </Dialog>
  );
  return { confirm, element };
}
